import React from 'react';

export default function PlaceholderMedia({ tipo, nombreArchivo, codigo }) {
  const icono = tipo === 'audio' ? '🎵' : tipo === 'pdf' ? '📄' : tipo === 'recurso' ? '📁' : tipo === 'interactivo' ? '🖥️' : tipo === 'practicario' ? '🧮' : tipo === 'test' ? '📝' : '🎬';
  const fileName = nombreArchivo ? decodeURIComponent(nombreArchivo.split('/').pop()) : null;
  const tipoLabel = tipo === 'audio' ? 'Audio' : tipo === 'pdf' ? 'PDF' : tipo === 'recurso' ? 'Recurso' : tipo === 'interactivo' ? 'Interactivo' : tipo === 'practicario' ? 'Practicario' : tipo === 'test' ? 'Test' : 'Video';
  const mensajeBase = tipo === 'audio' ? 'Audio solo disponible en libro digital' : tipo === 'pdf' ? 'PDF solo disponible en libro digital' : tipo === 'recurso' ? 'Recursos solo disponibles en libro digital' : tipo === 'interactivo' ? 'Interactivo solo disponible en libro digital' : tipo === 'practicario' ? 'Practicario solo disponible en libro digital' : tipo === 'test' ? 'Test solo disponible en libro digital' : 'Video solo disponible en libro digital';
  const mensajeSinArchivo = codigo ? `${mensajeBase} (${codigo})` : mensajeBase;

  return (
    <div className="my-4 md:my-8 w-full flex justify-center items-center bg-gray-100 border-2 border-dashed border-gray-300 rounded-lg p-8">
      <div className="text-center">
        <div className="text-4xl mb-2">{icono}</div>
        {(tipo === 'pdf' || tipo === 'recurso') && nombreArchivo ? (
          <a 
            href={nombreArchivo} 
            target="_blank" 
            rel="noopener noreferrer" 
            className="text-blue-600 hover:text-blue-800 underline font-medium break-all"
          >
            {nombreArchivo}
          </a>
        ) : fileName ? (
          <p className="text-gray-600 font-medium">{tipoLabel}: {fileName}</p>
        ) : (
          <p className="text-gray-600 font-medium">{mensajeSinArchivo}</p>
        )}
      </div>
    </div>
  );
}
